import { classLangTypeSchema, classLessonTimeSchema, ticketLangTypeSchema } from '@server/presentation'
import { z } from 'zod'

export const rawLessonTicketEntitySchema = z.object({
  id: z.string(),
  reason: z.string(),
  origin_count: z.number(),
  purchased_count: z.number(),
  used_count: z.number(),
  destroy_count: z.number(),
  refund_count: z.number(),
  remain_count_num: z.number(),
  remain_count: z.string(),
  ticket_start_date: z.string(),
  ticket_expire_date: z.string(),
  event_type: z.string(),
  payment_lang_type: ticketLangTypeSchema,
  lang_type: classLangTypeSchema,
  lang_type_name: z.string(),
  subscribe_mapp_id: z.string(),
  goods_name: z.string(),
  payment_id: z.string().nullable(),
  lesson_time: classLessonTimeSchema,
})

export const lessonTicketEntitySchema = z.object({
  id: z.string(),
  reason: z.string(),
  originCount: z.number(),
  purchasedCount: z.number(),
  usedCount: z.number(),
  destroyCount: z.number(),
  refundCount: z.number(),
  remainCountNum: z.number(),
  remainCount: z.string(),
  ticketStartDate: z.string(),
  ticketExpireDate: z.string(),
  eventType: z.string(),
  paymentLangType: ticketLangTypeSchema,
  langType: classLangTypeSchema,
  langTypeName: z.string(),
  subscribeMappId: z.string(),
  goodsName: z.string(),
  paymentId: z.string().nullable(),
  lessonTime: classLessonTimeSchema,
})

export const lessonTicketEntityAdapter = (rawLessonTicketEntity: RawLessonTicketEntity): LessonTicketEntity => {
  return {
    id: rawLessonTicketEntity.id,
    reason: rawLessonTicketEntity.reason,
    originCount: rawLessonTicketEntity.origin_count,
    purchasedCount: rawLessonTicketEntity.purchased_count,
    usedCount: rawLessonTicketEntity.used_count,
    destroyCount: rawLessonTicketEntity.destroy_count,
    refundCount: rawLessonTicketEntity.refund_count,
    remainCountNum: rawLessonTicketEntity.remain_count_num,
    remainCount: rawLessonTicketEntity.remain_count,
    ticketStartDate: rawLessonTicketEntity.ticket_start_date,
    ticketExpireDate: rawLessonTicketEntity.ticket_expire_date,
    eventType: rawLessonTicketEntity.event_type,
    paymentLangType: rawLessonTicketEntity.payment_lang_type,
    langType: rawLessonTicketEntity.lang_type,
    langTypeName: rawLessonTicketEntity.lang_type_name,
    subscribeMappId: rawLessonTicketEntity.subscribe_mapp_id,
    goodsName: rawLessonTicketEntity.goods_name,
    paymentId: rawLessonTicketEntity.payment_id,
    lessonTime: rawLessonTicketEntity.lesson_time,
  } satisfies LessonTicketEntity
}

export type RawLessonTicketEntity = z.infer<typeof rawLessonTicketEntitySchema>
export type LessonTicketEntity = z.infer<typeof lessonTicketEntitySchema>
